import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import {
  FaLaptopCode,
  FaPython,
  FaJava,
  FaMobile,
  FaCloud,
  FaMicrochip,
  FaRobot,
  FaIndustry,
  FaArrowRight,
  FaQuestionCircle,
  FaBuilding,
  FaUserGraduate,
  FaCheckCircle,
  FaStar,
  FaUsers,
  FaTrophy,
  FaCalendarAlt,
  FaBriefcase,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import PublicNavbar from "../../components/public/Navbar";
import Footer from "../../components/public/Footer";
import "../../styles/internship.css";

const Internship = () => {
  const navigate = useNavigate();
  const [openFaq, setOpenFaq] = useState(null);
  const [activeFilter, setActiveFilter] = useState("all");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const courses = [
    {
      icon: <FaLaptopCode />,
      title: "Web Development",
      color: "#3498DB",
      description:
        "HTML, CSS, JavaScript, React.js, Node.js, PHP, MySQL, MongoDB",
      path: "/courses",
    },
    {
      icon: <FaPython />,
      title: "Python Programming",
      color: "#2ECC71",
      description:
        "Core concepts, OOP, NumPy, Pandas, Matplotlib, Django framework",
      path: "/courses",
    },
    {
      icon: <FaJava />,
      title: "Java Development",
      color: "#E74C3C",
      description:
        "OOP, Collections, Multithreading, JDBC with MySQL, Spring Boot",
      path: "/courses",
    },
    {
      icon: <FaMobile />,
      title: "Android App",
      color: "#9B59B6",
      description:
        "Flutter, Dart, Cross-platform apps, UI design, API integration",
      path: "/courses",
    },
    {
      icon: <FaCloud />,
      title: "AWS Cloud",
      color: "#F39C12",
      description: "EC2, S3, RDS, Lambda, IAM, VPC, CloudWatch, CloudFormation",
      path: "/courses",
    },
    {
      icon: <FaMicrochip />,
      title: "Arduino",
      color: "#1ABC9C",
      description:
        "Circuit design, Motor control, Sensor integration, C/C++ programming",
      path: "/courses",
    },
    {
      icon: <FaRobot />,
      title: "Robotics & IoT",
      color: "#E67E22",
      description:
        "Arduino, Raspberry Pi, Sensors, Actuators, IoT protocols, MQTT",
      path: "/courses",
    },
    {
      icon: <FaIndustry />,
      title: "PLC & SCADA",
      color: "#34495E",
      description:
        "Industrial automation, Siemens, Allen-Bradley, Ladder logic, HMI",
      path: "/courses",
    },
  ];

  const stats = [
    {
      icon: <FaUsers />,
      number: "2000+",
      label: "Interns Trained",
      color: "#3498DB",
    },
    {
      icon: <FaTrophy />,
      number: "95%",
      label: "Success Rate",
      color: "#2ECC71",
    },
    {
      icon: <FaCalendarAlt />,
      number: "21+",
      label: "Years Experience",
      color: "#F39C12",
    },
    {
      icon: <FaStar />,
      number: "4.9",
      label: "Student Rating",
      color: "#E74C3C",
    },
  ];

  const whyChoose = [
    {
      icon: <FaBuilding />,
      title: "Industry Experience",
      desc: "21+ years of experience, trained thousands of students",
      color: "#3498DB",
    },
    {
      icon: <FaLaptopCode />,
      title: "Hands-On Learning",
      desc: "Work on real software projects with industry-standard tools",
      color: "#2ECC71",
    },
    {
      icon: <FaUserGraduate />,
      title: "Certification",
      desc: "Recognized certificate, project report, and LOR for top performers",
      color: "#9B59B6",
    },
    {
      icon: <FaRobot />,
      title: "Future-Proof Skills",
      desc: "Skills that benefit in academic and career pursuits",
      color: "#E67E22",
    },
  ];

  const projects = [
    {
      id: 1,
      title: "E-Commerce Platform",
      category: "web",
      icon: "🛒",
      student: "Rahul S.",
      description: "Full-stack e-commerce with payment gateway integration",
    },
    {
      id: 2,
      title: "Health Care App",
      category: "mobile",
      icon: "🏥",
      student: "Priya M.",
      description: "Doctor appointment booking and telemedicine platform",
    },
    {
      id: 3,
      title: "Line Following Robot",
      category: "robotics",
      icon: "🤖",
      student: "Amit K.",
      description: "Autonomous robot using IR sensors and Arduino",
    },
    {
      id: 4,
      title: "Smart Home System",
      category: "robotics",
      icon: "🏠",
      student: "Neha S.",
      description: "IoT based home automation with mobile control",
    },
    {
      id: 5,
      title: "Portfolio Website",
      category: "web",
      icon: "💼",
      student: "Vikram P.",
      description: "Responsive personal portfolio with animations",
    },
    {
      id: 6,
      title: "Weather App",
      category: "mobile",
      icon: "🌤️",
      student: "Anjali R.",
      description: "Real-time weather application with API integration",
    },
  ];

  const filteredProjects =
    activeFilter === "all"
      ? projects
      : projects.filter((p) => p.category === activeFilter);

  const faqs = [
    {
      q: "👨‍🎓 Who can apply for the internship programs?",
      a: "Students pursuing B.Tech, M.Tech, MCA, BCA, B.Sc, M.Sc in Computer Science or IT are eligible to apply.",
    },
    {
      q: "⏰ What is the duration of the internship?",
      a: "Our internship program is a 45-day paid summer internship with flexible duration options.",
    },
    {
      q: "💰 What are the fees for the internship program?",
      a: "The internship program is paid. We offer stipends based on performance. Contact us for details.",
    },
    {
      q: "🏆 Will I receive a certificate after completion?",
      a: "Yes, you will receive a recognized certificate from Sensible Academy and a Letter of Recommendation for top performers.",
    },
    {
      q: "💻 What is the mode of the internship?",
      a: "We offer both Online and Offline (in-person at our Bhilai center) internship modes.",
    },
    {
      q: "🎯 Do I need prior experience or knowledge to join?",
      a: "Basic programming knowledge is recommended but not mandatory. We start from fundamentals.",
    },
  ];

  return (
    <div className="internship-page-wrapper">
      <PublicNavbar />
      <div className="internship-page-nav-spacer"></div>

      {/* Hero Section */}
      <section className="internship-page-hero">
        <div className="internship-page-hero-bubbles">
          <div className="internship-page-bubble"></div>
          <div className="internship-page-bubble"></div>
          <div className="internship-page-bubble"></div>
          <div className="internship-page-bubble"></div>
          <div className="internship-page-bubble"></div>
        </div>
        <Container>
          <div className="internship-page-hero-content">
            <div className="internship-page-hero-badge">
              <span>🔥</span>
              <span>Limited Seats Available for 2026 Batch</span>
              <span>✨</span>
            </div>
            <h1 className="internship-page-hero-title">
              INTERNSHIP PROGRAM /
              <span className="internship-page-highlight">
                {" "}
                INDUSTRIAL TRAINING
              </span>
            </h1>
            <h2 className="internship-page-hero-subtitle">
              Our Goal: To Make You Industry Ready!
            </h2>
            <p className="internship-page-hero-description">
              At Sensible Computers and Sensible Academy, we don't just offer
              internships—we build career foundations. Our 45-day paid summer
              internship program is designed specifically for Computer Science
              and IT students to gain real-world experience.
            </p>
            <div className="internship-page-hero-buttons">
              <button
                className="internship-page-hero-btn-primary"
                onClick={() => navigate("/contact")}
              >
                Apply Now <FaArrowRight className="ms-2" />
              </button>
              <button
                className="internship-page-hero-btn-secondary"
                onClick={() => navigate("/contact")}
              >
                Download Brochure
              </button>
            </div>
          </div>
        </Container>
        <div className="internship-page-hero-wave">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 120"
            preserveAspectRatio="none"
          >
            <path
              fill="#ffffff"
              fillOpacity="1"
              d="M0,64L48,80C96,96,192,128,288,128C384,128,480,96,576,85.3C672,75,768,85,864,96C960,107,1056,117,1152,112C1248,107,1344,85,1392,74.7L1440,64L1440,120L1392,120C1344,120,1248,120,1152,120C1056,120,960,120,864,120C768,120,672,120,576,120C480,120,384,120,288,120C192,120,96,120,48,120L0,120Z"
            ></path>
          </svg>
        </div>
      </section>

      {/* Stats Section */}
      <Container className="internship-page-stats">
        <Row className="g-4">
          {stats.map((stat, index) => (
            <Col md={3} sm={6} key={index}>
              <div className="internship-page-stat-card">
                <div
                  className="internship-page-stat-icon"
                  style={{ background: stat.color }}
                >
                  {stat.icon}
                </div>
                <h3>{stat.number}</h3>
                <p>{stat.label}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Why Choose Us Section */}
      <Container className="internship-page-container">
        <div className="internship-page-section-header text-center">
          <h2>
            Why Should You{" "}
            <span className="internship-page-highlight">Choose Us</span>?
          </h2>
          <p>
            Vocational training bridges the gap between academic learning and
            industry requirements
          </p>
        </div>
        <Row className="g-4">
          {whyChoose.map((item, index) => (
            <Col md={3} sm={6} key={index}>
              <div className="internship-page-why-card">
                <div
                  className="internship-page-why-icon"
                  style={{ background: item.color }}
                >
                  {item.icon}
                </div>
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Programs Section */}
      <section className="internship-page-courses-section">
        <Container>
          <div className="internship-page-section-header text-center">
            <h2>
              Internship{" "}
              <span className="internship-page-highlight">Programs</span>
            </h2>
            <p>Choose your specialization from our industry-aligned programs</p>
          </div>
          <Row className="g-4">
            {courses.map((course, index) => (
              <Col md={6} lg={3} key={index}>
                <div className="internship-page-course-card">
                  <div
                    className="internship-page-course-icon"
                    style={{ backgroundColor: course.color }}
                  >
                    {course.icon}
                  </div>
                  <h3>{course.title}</h3>
                  <p>{course.description}</p>
                  <button
                    className="internship-page-course-btn"
                    onClick={() => navigate(course.path)}
                  >
                    Learn More →
                  </button>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Portfolio Section */}
      <Container className="internship-page-container">
        <div className="internship-page-section-header text-center">
          <h2>
            Student <span className="internship-page-highlight">Portfolio</span>
          </h2>
          <p>Celebrating the incredible work of our students</p>
        </div>

        <div className="internship-page-portfolio-filters">
          <button
            className={`internship-page-filter-btn ${activeFilter === "all" ? "active" : ""}`}
            onClick={() => setActiveFilter("all")}
          >
            ALL
          </button>
          <button
            className={`internship-page-filter-btn ${activeFilter === "web" ? "active" : ""}`}
            onClick={() => setActiveFilter("web")}
          >
            🌐 WEB APPS
          </button>
          <button
            className={`internship-page-filter-btn ${activeFilter === "robotics" ? "active" : ""}`}
            onClick={() => setActiveFilter("robotics")}
          >
            🤖 ROBOTICS
          </button>
          <button
            className={`internship-page-filter-btn ${activeFilter === "mobile" ? "active" : ""}`}
            onClick={() => setActiveFilter("mobile")}
          >
            📱 MOBILE APPS
          </button>
        </div>

        <Row className="g-4">
          {filteredProjects.map((project) => (
            <Col md={6} lg={4} key={project.id}>
              <div className="internship-page-portfolio-card">
                <div className="internship-page-portfolio-icon">
                  {project.icon}
                </div>
                <div className="internship-page-portfolio-info">
                  <h4>{project.title}</h4>
                  <p>{project.description}</p>
                  <div className="internship-page-portfolio-student">
                    <FaCheckCircle className="me-1" /> {project.student}
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      {/* FAQ Section */}
      <section className="internship-page-faq-section">
        <Container>
          <div className="internship-page-section-header text-center">
            <h2>
              Frequently Asked{" "}
              <span className="internship-page-highlight">Questions</span>
            </h2>
            <p>Get answers to common internship questions</p>
          </div>
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="internship-page-faq-container">
                {faqs.map((faq, index) => (
                  <div
                    key={index}
                    className={`internship-page-faq-item ${openFaq === index ? "active" : ""}`}
                  >
                    <div
                      className="internship-page-faq-question"
                      onClick={() => toggleFaq(index)}
                    >
                      <h4>{faq.q}</h4>
                      <span className="internship-page-faq-icon">
                        {openFaq === index ? "−" : "+"}
                      </span>
                    </div>
                    <div className="internship-page-faq-answer">
                      <p>{faq.a}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="internship-page-cta-section">
        <Container>
          <Row className="align-items-center">
            <Col lg={8}>
              <div className="internship-page-cta-content">
                <h2>Ready to Start Your Internship Journey?</h2>
                <p>
                  Join hundreds of successful interns who transformed their
                  careers with us
                </p>
                <div className="internship-page-cta-buttons">
                  <button
                    className="internship-page-cta-primary"
                    onClick={() => navigate("/contact")}
                  >
                    Apply Now <FaArrowRight className="ms-2" />
                  </button>
                  <button
                    className="internship-page-cta-secondary"
                    onClick={() => navigate("/contact")}
                  >
                    Contact Us
                  </button>
                </div>
              </div>
            </Col>
            <Col lg={4} className="text-center">
              <div className="internship-page-cta-emoji">
                <span>💼</span>
                <span>🚀</span>
                <span>🎓</span>
                <span>🏆</span>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </div>
  );
};

export default Internship;
